import { CommonDataDTO } from './../../requests/model/combos-model';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { UserDataCreate } from '../model/users-model';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateComponent implements OnInit {
  radioButtonsList: string[] = ['Grupo', 'Prescriptor', 'Establecimiento', 'Vendedor'];
  selection = new SelectionModel<string>(false, []);
  checkedWebService: boolean = false;
  isWebService: boolean = false;
  activateUserEmail: boolean = false;
  userType: string;
  passwordWebService: string;
  userSelected: CommonDataDTO;
  userSelectedData: UserDataCreate;

  ngOnInit() {}
}
